import type { Meta, StoryObj } from "@storybook/react";

import type { BaseOnboardingCardProps } from "@/ui/components/onboarding/v2/cards/BaseOnboardingCard";
import { BaseOnboardingCard } from "@/ui/components/onboarding/v2/cards/BaseOnboardingCard";
import { Text } from "@/ui/core";
import { VStack } from "@/ui/layout";

const StoryMeta: Meta<BaseOnboardingCardProps> = {
  title: "Components/Onboarding/Cards/Base Onboarding Card",
  component: BaseOnboardingCard,
  argTypes: {
    borderRadius: {
      control: "select",
      options: ["default", "large"],
    },
    hasShadow: {
      control: "boolean",
    },
    isBorderDashed: {
      control: "boolean",
    },
  },
  render: (args) => (
    <BaseOnboardingCard {...args}>
      <Text testID="content" variant="body">
        Card content
      </Text>
    </BaseOnboardingCard>
  ),
};

type Story = StoryObj<BaseOnboardingCardProps>;

const Default: Story = {};

const Dashed: Story = {
  args: { isBorderDashed: true },
};

const WithShadow: Story = {
  args: { hasShadow: true },
};

const AllVariants: Story = {
  render: () => (
    <VStack gap={12}>
      <BaseOnboardingCard testID="default">
        <Text testID="default-text" variant="body">
          Default (solid border)
        </Text>
      </BaseOnboardingCard>
      <BaseOnboardingCard isBorderDashed testID="dashed">
        <Text testID="dashed-text" variant="body">
          Dashed border
        </Text>
      </BaseOnboardingCard>
      <BaseOnboardingCard hasShadow testID="shadow">
        <Text testID="shadow-text" variant="body">
          With shadow
        </Text>
      </BaseOnboardingCard>
      <BaseOnboardingCard
        borderRadius="large"
        hasShadow
        isBorderDashed
        testID="all-variants"
      >
        <Text testID="all-variants-text" variant="body">
          Large, dashed, with shadow
        </Text>
      </BaseOnboardingCard>
    </VStack>
  ),
};

export { AllVariants, Dashed, Default, WithShadow };
export default StoryMeta;
